module.exports = __webpack_public_path__ + "static/media/curriculum_s1.b486e6b6.png";